// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XCdX1","rootParamsCollapsed":"styles_rootParamsCollapsed__I31Or","rootPreviewFull":"styles_rootPreviewFull__2WnEr","loader":"styles_loader__rYNpO"};